import { Component, ElementRef, HostListener, Injector, Input, ViewChild } from '@angular/core';
import { ResizedEvent } from 'angular-resize-event';
import { LocaleDataService } from 'src/app/submodules/angular-common/locale-data.service';
import { PageLayoutDataService } from 'src/app/submodules/angular-common/page-layout-data.service';
import { CanvasLayoutDataService } from '../../../../submodules/angular-common/canvas-layout-data.service';
import { BaseView } from '../../base-view';

@Component({
  selector: 'app-canvas-layout',
  templateUrl: './canvas-layout.component.html',
  styleUrls: ['./canvas-layout.component.scss']
})
export class CanvasLayoutComponent extends BaseView {

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    // console.log('window:resize :>> ', event);
    this.canvasLayoutDataService.onResize();
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    // console.log('window:scroll :>> ', event);
  }

  onPageBodyResize(event: ResizedEvent) {
    // console.log('onPageBodyResize :>> ', event);
    this.canvasLayoutDataService.pageBodyWidth = event.newWidth;
    this.canvasLayoutDataService.pageBodyHeight = event.newHeight;
  }

  constructor(
    public canvasLayoutDataService: CanvasLayoutDataService,
    public pageLayoutDataService: PageLayoutDataService,
    public localeDataService: LocaleDataService, 
    protected _injector: Injector
  ) {
    super(_injector)
  }

  ngOnInit(): void {
    this.onResize(null)
  }
}
